import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofzWoofy } from './pages-map'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_WOOFY: Record<
  PageIdWoofzWoofy,
  TPageConfig
> = {
  [PageIdWoofzWoofy.HELLO_WOOFY]: {
    id: PageIdWoofzWoofy.HELLO_WOOFY,
  },
  [PageIdWoofzWoofy.COACH_WOOFY]: {
    id: PageIdWoofzWoofy.COACH_WOOFY,
  },
  [PageIdWoofzWoofy.CHAT_WOOFY]: {
    id: PageIdWoofzWoofy.CHAT_WOOFY,
  },
  [PageIdWoofzWoofy.DOG_AGE_WOOFY]: {
    id: PageIdWoofzWoofy.DOG_AGE_WOOFY,
  },
  [PageIdWoofzWoofy.BEHAVIOR_WOOFY]: {
    id: PageIdWoofzWoofy.BEHAVIOR_WOOFY,
  },
  [PageIdWoofzWoofy.URGE_WOOFY]: {
    id: PageIdWoofzWoofy.URGE_WOOFY,
  },
  [PageIdWoofzWoofy.PREPARE_FLOW_WOOFY]: {
    id: PageIdWoofzWoofy.PREPARE_FLOW_WOOFY,
  },
  [PageIdWoofzWoofy.EMAIL_WOOFY]: {
    id: PageIdWoofzWoofy.EMAIL_WOOFY,
  },
  [PageIdWoofzWoofy.SUBSCRIPTIONS_WOOFY]: {
    id: PageIdWoofzWoofy.SUBSCRIPTIONS_WOOFY,
  },
  [PageIdWoofzWoofy.DOWNLOAD_WOOFY]: {
    id: PageIdWoofzWoofy.DOWNLOAD_WOOFY,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzWoofy.ACCOUNT_WOOFY]: {
    id: PageIdWoofzWoofy.ACCOUNT_WOOFY,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
